
<template>
    <v-container fluid class="px-0 pb-0" v-resize="myEventHandler">
        <div>
            <v-card-title primary-title>
                <v-row dense justify="space-between">
                    <v-col cols="12" sm="8">
                        <div
                            v-if="$vuetify.breakpoint.mdAndDown"
                            :class="`primary--text text-overline ml-2 ${
                                $vuetify.breakpoint.xs ? 'text-center' : ''
                            }`"
                        >
                            Gestión Tipos de Objetivo
                        </div>
                        <div
                            v-else
                            class="
                                font-weight-light
                                primary--text
                                text-h4
                                ml-2
                                text-capitalize
                            "
                        >
                            Gestión Tipos de Objetivo
                        </div>
                    </v-col>
                    <v-col
                        sm="4"
                        cols="12"
                        :class="`d-flex align-center ${
                            $vuetify.breakpoint.xs
                                ? 'justify-center'
                                : 'justify-end'
                        }`"
                    >
                        <!-- <v-progress-circular
                            width="2"
                            v-if="tariffManagement.isLoading"
                            :size="30"
                            color="black"
                            indeterminate
                        ></v-progress-circular> -->
                        <v-btn
                            @click="openAddingForm()"
                            color="green"
                            class="mr-2"
                            :small="$vuetify.breakpoint.mdAndDown"
                            text
                        >
                            Nuevo Tipo de Objetivo
                            <v-icon
                                :right="!$vuetify.breakpoint.mdAndDown"
                                :small="$vuetify.breakpoint.mdAndDown"
                            >
                                mdi-pen-plus
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <!-- <v-divider class="test"></v-divider> -->
            <v-data-table
                :height="tableHeight"
                :headers="headers"
                :items="objectives"
                :search="search"
                :items-per-page="footerProps.itemsPerPageOptions"
                class="px-2"
            >
                <template v-slot:item.is_active="{ item }">
                    <v-icon :color="item.is_active ? 'green' : 'red'">
                        mdi-circle
                    </v-icon>
                </template>
                <template v-slot:item.Actions="{ item }">
                    <v-row>
                        <v-col md="3">
                            <v-btn
                                class="d-flex grow justify-center flex-wrap"
                                fab
                                x-small
                                color="primary"
                                text
                                @click="watchingForm(item)"
                            >
                                <v-icon> mdi-information-slab-box </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col md="3">
                            <v-btn
                                class="d-flex grow justify-center flex-wrap"
                                fab
                                x-small
                                color="orange"
                                text
                                @click="editingForm(item)"
                            >
                                <v-icon> mdi-pen </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col md="2" v-if="hasSuperAdminPermission">
                            <v-btn
                                class="d-flex grow justify-center flex-wrap"
                                fab
                                x-small
                                color="red"
                                text
                                @click="openConfirmdelete(item)"
                            >
                                <v-icon> mdi-delete-empty-outline </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>
        </div>
        <ObjectiveTypesManagementForm />
    </v-container>
</template>

<script>
import ObjectiveTypesManagementForm from '@/components/GerenciaTeletrabajo/Management/INDBOPROManagement/ObjectiveTypesManagement/ObjectiveTypesManagementForm.vue';
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'ObjectiveTypesManagementTable',
    components: {
        ObjectiveTypesManagementForm,
    },
    data: () => ({
        tableHeight: 300,
        footerProps: {
            itemsPerPageOptions: [10],
        },
        headers: [
            { text: 'ID', value: 'id' },
            { text: 'Nombre', value: 'nombre' },
            {
                text: 'Acciones',
                value: 'Actions',
                align: 'center',
                sortable: false,
                width: '150px',
            },
        ],
    }),
    methods: {
        setForm(item) {
            this.$store.state.ManagementBase.objectiveTypesManagement.Name =
                item.nombre;
            this.$store.state.ManagementBase.objectiveTypesManagement.Id =
                item.id;
            this.$store.state.ManagementBase.objectiveTypesManagement.editingId =
                item.id;
        },
        closeOtherForms() {
            this.$store.state.ManagementBase.insuranceManagement.isOpenDialog = false;
            this.$store.state.ManagementBase.procedureManagement.isOpenDialog = false;
        },
        openAddingForm() {
            this.closeOtherForms();
            this.$store.commit(
                'ManagementBase/objectiveTypesManagement/formType',
                'add'
            );
            this.$store.commit(
                'ManagementBase/objectiveTypesManagement/isEditableForm',
                false
            );
            this.$store.commit(
                'ManagementBase/objectiveTypesManagement/isOpenDialog',
                true
            );
        },
        openConfirmdelete(item) {
            let deleteData = {
                module: 'ManagementBase/objectiveTypesManagement',
                item: item,
            };

            this.$store.commit('ManagementBase/confirmDeletion', {
                val: true,
                deleteData,
            });
        },
        watchingForm(item) {
            this.closeOtherForms();
            this.setForm(item);
            this.$store.commit(
                'ManagementBase/objectiveTypesManagement/formType',
                'watch'
            );
            this.$store.commit(
                'ManagementBase/objectiveTypesManagement/isOpenDialog',
                true
            );
            this.$store.commit(
                'ManagementBase/objectiveTypesManagement/isEditableForm',
                true
            );
        },
        editingForm(item) {
            this.closeOtherForms();
            this.setForm(item);
            this.$store.commit(
                'ManagementBase/objectiveTypesManagement/formType',
                'edit'
            );
            this.$store.commit(
                'ManagementBase/objectiveTypesManagement/isOpenDialog',
                true
            );
            this.$store.commit(
                'ManagementBase/objectiveTypesManagement/isEditableForm',
                false
            );
        },
        determineWidth() {
            let width = window.innerWidth;
            let height = 0;
            if (this.$vuetify.breakpoint.smAndDown) {
                height = 294;
            } else if (this.$vuetify.breakpoint.mdAndDown) {
                height = 234;
            } else {
                if (width < 1661) {
                    height = 258;
                } else {
                    height = 242;
                }
            }
            return height + 62;
        },
        myEventHandler() {
            // Get width of the window
            this.tableHeight =
                document.getElementById('fullHeigth')?.clientHeight -
                this.determineWidth();
        },
    },
    computed: {
        ...mapState('ManagementBase/objectiveTypesManagement', {
            objectives: (state) => state.objectives,
        }),
        ...mapState('ManagementBase', {
            loadingItems: (state) => state.loadingItems,
        }),
        ...mapState('util', {
            search: (state) => state.navBarSearchField,
        }),
        ...mapGetters('login', {
            hasSuperAdminPermission: 'hasSuperAdminPermission',
        }),
    },
    watch: {
        tableHeight() {
            this.footerProps.itemsPerPageOptions = Math.floor(
                this.tableHeight / 48 - 1
            );
        },
    },
};
</script>

<style>
</style>